// Pain Point URL Parameter Tracking
(function() {
  const params = new URLSearchParams(window.location.search);
  const painpoint = params.get('painpoint');

  if (painpoint) {
    sessionStorage.setItem('painpoint', painpoint);
  }
})();

// Helper function to get painpoint from session
window.getPainpoint = function() {
  return sessionStorage.getItem('painpoint');
};

// Shopify cart endpoints (if the theme does not define them)
const cartRoutes = (window.theme && theme.cartRoutes) || {
  cartAddUrl: '/cart/add',
  cartUpdateUrl: '/cart/update',
  cartChangeUrl: '/cart/change',
  cartClearUrl: '/cart/clear'
};

// ----------- Helpers -----------
async function fetchJSON(url, options = {}) {
  const response = await fetch(url, options);
  const json = await response.json();
  if (json.status && json.status !== 200) {
    throw new Error(json.description || 'Shopify API error');
  }
  return json;
}

async function fetchMultipleRequests(data, url) {
  for (const data_item of data) {
    const json = await fetchJSON(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data_item)
    });

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'upsell_subscription_upgrade',
      ecommerce: { items: json.items }
    });
  }
}

// ----------- Subscription Switch -----------
document.addEventListener('change', async (e) => {
  const input = e.target.closest('[name="subscription-switch"]');
  if (!input) return;

  input.setAttribute('disabled', 'disabled');
  const container = document.querySelector('.cart-drawer');
  if (container) container.setAttribute('loading', '');

  const dataArray = [];
  if (input.checked) {
    document.querySelectorAll('.cart-item[data-cart-item-is-subscription="false"][data-cart-item-has-subscription-plans="true"]').forEach(item => {
      dataArray.push({
        id: item.dataset.cartItemKey,
        quantity: parseInt(item.dataset.cartItemQuantity),
        selling_plan: parseInt(item.dataset.cartItemFirstSubscriptionPlanId)
      });
    });
  } else {
    document.querySelectorAll('.cart-item[data-cart-item-is-subscription="true"][data-cart-item-has-subscription-plans="true"]').forEach(item => {
      dataArray.push({
        id: item.dataset.cartItemKey,
        quantity: parseInt(item.dataset.cartItemQuantity),
        selling_plan: null
      });
    });
  }

  try {
    await fetchMultipleRequests(dataArray, cartRoutes.cartChangeUrl + '.js');
    await renderCartDrawer();
  } catch (err) {
    console.error(err);
  } finally {
    input.removeAttribute('disabled');
    if (container) container.removeAttribute('loading');
  }
});

// ----------- Upsell Upgrade -----------
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-cart-drawer-upsell-form]');
  if (!form) return;
  e.preventDefault();

  const container = document.querySelector('.cart-drawer');
  if (container) container.setAttribute('loading', '');

  try {
    const baseItemKey = form.dataset.baseItemKey;

    await fetchJSON(cartRoutes.cartUpdateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [baseItemKey]: 0 } })
    });

    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'properties[_upsell]';
    hiddenInput.value = 'true';
    form.appendChild(hiddenInput);

    const formData = new URLSearchParams(new FormData(form));

    // Add painpoint as cart attribute if exists
    const painpoint = window.getPainpoint();
    if (painpoint) {
      formData.append('attributes[painpoint]', painpoint);
    }

    const json = await fetchJSON(cartRoutes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'upsell_upgrade',
      ecommerce: {
        items: [
          {
            item_id: json.id,
            item_name: json.title,
            item_brand: json.vendor,
            item_variant: json.id,
            currency: Shopify.currency.active,
            price: json.price / 100
          }
        ]
      }
    });

    await renderCartDrawer();
  } catch (err) {
    console.error('Error in upsell form:', err);
  } finally {
    if (container) container.removeAttribute('loading');
  }
});  


// CART DISCOUNT

const cartContainer = document.querySelector('#shopify-section-cart-drawer');

if (cartContainer) {
  const observer = new MutationObserver(() => {
    observer.disconnect(); 
    calculateDiscount();
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    }); 
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });

  calculateDiscount();
}

function calculateDiscount() {
  const lineItems = document.querySelectorAll('[data-variant-old-price]');
  if (!lineItems.length) return;

  const cartTotalEl = document.querySelector('[data-cart-total-price]');
  const discountEl = document.querySelector('[data-alternative-cart-discount]');
  // Two nodes share this attr (redesign old-price + default footer). Update both.
  const cartSubtotalEls = document.querySelectorAll('[data-cart-subtotal-price]');

  let oldTotal = 0;
  let saleTotal = 0;
  let discountTotal = 0;

  lineItems.forEach(item => {
    let oldPrice = parseFloat(item.getAttribute('data-variant-old-price')) || 0;
    let salePrice = parseFloat(item.getAttribute('data-variant-sale-price')) || 0;

    let quantity = parseInt(item.getAttribute('data-cart-item-quantity')) || 0;
    oldTotal += oldPrice * quantity;
    saleTotal += salePrice * quantity;
  });

  discountTotal = oldTotal - saleTotal;

  if (cartTotalEl) {
    cartTotalEl.textContent = `$${saleTotal.toFixed(2)}`;
  }

  if (discountEl) {
    discountEl.textContent = `$${discountTotal.toFixed(2)}`;
  }

  let oldTotalSum = Math.max(0, oldTotal * 100 ) / 100;
  const hasDiscount = discountTotal > 0.005;

  cartSubtotalEls.forEach((el) => {
    const isRedesignOldPrice = el.classList.contains('cart-drawer__redesign-summary-old-price');

    // Redesign compare-at price stays empty when there is no discount
    if (isRedesignOldPrice && !hasDiscount) {
      el.textContent = '';
      return;
    }

    el.textContent = `$${oldTotalSum.toFixed(2)}`;
  });
}

async function fetchJSON(url, options = {}) {
  try {
    const response = await fetch(url, {
      method: options.method || 'GET',
      credentials: 'same-origin',
      headers: options.headers || {},
      body: options.body || null,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, response: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

async function fetchSectionHtml(sectionId) {
  const response = await fetch(`/?section_id=${sectionId}&timestamp=${Date.now()}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const text = await response.text();
  return text
    .replace(/<!-- BEGIN static -->/g, '')
    .replace(/<!-- END static -->/g, '');
}

function updateCartIconFromSection(sectionHtml) {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble || !sectionHtml) return;

  const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const sectionEl = doc.querySelector('.shopify-section') || doc.body;
  if (!sectionEl) return;

  cartIconBubble.innerHTML = sectionEl.innerHTML;
}

async function renderCartDrawer(options = {}) {
  const forceOpen = Boolean(options.open);
  const oldDrawerWrapper = document.querySelector('.drawer');
  const wasOpen = oldDrawerWrapper?.classList.contains('active') || false;

  try {
    // Sections HTML can be passed in (e.g. from a cart API response with `sections`) to skip two GETs.
    const given = options.sections || {};
    const [drawerText, cartIconText] = given['cart-drawer']
      ? [given['cart-drawer'], given['cart-icon-bubble'] || '']
      : await Promise.all([fetchSectionHtml('cart-drawer'), fetchSectionHtml('cart-icon-bubble')]);

    const parser = new DOMParser();
    const doc = parser.parseFromString(drawerText, 'text/html');

    const newSection = doc.querySelector('#shopify-section-cart-drawer');
    const currentSection = document.querySelector('#shopify-section-cart-drawer');

    if (newSection && currentSection) {
      const parent = currentSection.parentNode;
      const newElement = newSection.cloneNode(true);
      // Preserve an open drawer before insertion; do not replay its entrance
      // transition when gifts or cart quantities update its contents.
      if (wasOpen) newElement.querySelector('.drawer')?.classList.add('active', 'animate');
      parent.replaceChild(newElement, currentSection);
      window.applyCartRedesignState?.();

      const newDrawer = newElement.querySelector('.drawer');
      const cartDrawerEl = newElement.querySelector('cart-drawer');
      if (forceOpen && !wasOpen && cartDrawerEl?.open) {
        cartDrawerEl.open(document.activeElement);
      } else if (wasOpen && newDrawer) {
        newDrawer.classList.add('active');
        CartDrawer.lockPageScroll();
      } else if (!wasOpen) {
        CartDrawer.unlockPageScroll();
      }
    }

    updateCartIconFromSection(cartIconText);

    const cartCountEl =
      document.querySelector('[data-current-cart-count]') ||
      doc.querySelector('[data-current-cart-count]');
    const newCartCount = cartCountEl ? parseInt(cartCountEl.dataset.currentCartCount) || 0 : 0;

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = newCartCount;
    });
    document.querySelectorAll('.ch-cart-link').forEach((el) => {
      el.classList.toggle('not-empty', newCartCount > 0);
    });

    calculateDiscount();

    return new Promise((resolve) => requestAnimationFrame(() => resolve()));
  } catch (err) {
    console.error('renderCartDrawer error:', err);
    throw err;
  }
}

// PDP Popup

function getStickyHeaderOffset() {
  const header = document.querySelector('.section-header');
  const announcement = document.querySelector('.announcement-bar-section');
  const headerHeight = header ? header.offsetHeight : 0;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;

  return headerHeight + announcementHeight;
}

function isSafariBrowser() {
  const userAgent = window.navigator.userAgent;
  return /Safari/i.test(userAgent) && !/Chrome|CriOS|Chromium|Android/i.test(userAgent);
}

function getReviewScrollDuration() {
  return isSafariBrowser() ? 3000 : 500;
}

let pendingSafariReviewScroll = null;

function animateWindowScroll(targetY, duration = getReviewScrollDuration(), resolveTargetY) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const startY = window.pageYOffset;
  const distance = targetY - startY;

  if (reducedMotion || Math.abs(distance) < 2) {
    window.scrollTo(0, targetY);
    if (resolveTargetY) {
      requestAnimationFrame(() => window.scrollTo(0, resolveTargetY()));
    }
    return;
  }

  const startTime = performance.now();
  const easeInOut = isSafariBrowser()
    ? (progress) => 1 - Math.pow(1 - progress, 4)
    : (progress) => (
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2
      );

  const step = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const endY = resolveTargetY ? resolveTargetY() : targetY;
    const nextY = startY + ((endY - startY) * easeInOut(progress));

    window.scrollTo(0, nextY);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
}

function getJunipReviewTarget(preferredHash, currentMainProduct) {
  if (preferredHash) {
    const hashId = decodeURIComponent(preferredHash).replace(/^#/, '');
    const directTarget = hashId ? document.getElementById(hashId) : null;
    if (directTarget && !currentMainProduct?.contains(directTarget)) {
      return directTarget;
    }
  }

  const fallbackSelectors = [
    '[data-junip-product-review]',
    '[data-junip-reviews]',
    '.junip-product-review',
    '.junip-product-review-summary',
    '.junip-reviews-widget',
    '.junip-review-list',
    '[class*="junip"][class*="review"]',
    '[id*="junip"][id*="review"]'
  ];

  return fallbackSelectors
    .map((selector) => document.querySelector(selector))
    .find((element) => element && !currentMainProduct?.contains(element));
}

function getJunipReviewSectionFallback(currentMainProduct) {
  const mainSection = currentMainProduct?.closest('.shopify-section');
  if (!mainSection) return null;

  let nextSection = mainSection.nextElementSibling;

  while (nextSection) {
    const sectionFingerprint = `${nextSection.id || ''} ${nextSection.className || ''}`.toLowerCase();
    const hasJunipMarkup = nextSection.querySelector('[class*="junip"], [id*="junip"], [data-junip-product-review], [data-junip-reviews]');

    if (hasJunipMarkup || sectionFingerprint.includes('apps')) {
      return nextSection;
    }

    nextSection = nextSection.nextElementSibling;
  }

  return null;
}

function isJunipElement(element, boundary) {
  let currentElement = element;

  while (currentElement && currentElement !== boundary) {
    const className = typeof currentElement.className === 'string' ? currentElement.className : '';
    const fingerprint = `${currentElement.id || ''} ${className}`.toLowerCase();

    if (fingerprint.includes('junip')) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
}

function scrollToJunipReviews(triggerElement) {
  const mainProduct = triggerElement.closest('[id^="MainProduct-"]');
  const href = triggerElement.getAttribute('href') || '';
  const hash = href.includes('#') ? new URL(href, window.location.href).hash : '';
  const target = getJunipReviewTarget(hash, mainProduct) || getJunipReviewSectionFallback(mainProduct);

  if (!target) {
    return false;
  }

  const top = target.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset() - 16;
  animateWindowScroll(Math.max(0, top));

  return true;
}

function forceSafariReviewScroll(targetElement, startY, hash) {
  if (!targetElement) return false;

  const runScroll = () => {
    const top = targetElement.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset() - 16;
    window.scrollTo(0, startY);
    animateWindowScroll(Math.max(0, top), getReviewScrollDuration());
  };

  if (hash) {
    history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(runScroll);
  });

  return true;
}

function getClickableFromEvent(event) {
  const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];

  for (const item of eventPath) {
    if (!(item instanceof Element)) continue;
    if (item.matches('a, button, [role="button"], [role="link"]')) return item;
  }

  return event.target instanceof Element ? event.target.closest('a, button, [role="button"], [role="link"]') : null;
}

function pathContainsJunip(event, boundary) {
  const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];

  return eventPath.some((item) => item instanceof Element && isJunipElement(item, boundary));
}

document.addEventListener('click', function(e) {
  const nativeReviewSummary = e.target instanceof Element ? e.target.closest('[data-native-review-summary]') : null;
  if (nativeReviewSummary) {
    const mainProduct = nativeReviewSummary.closest('[id^="MainProduct-"]');
    if (!mainProduct) return;

    const startY = window.pageYOffset;
    const safariTarget = getJunipReviewSectionFallback(mainProduct) || getJunipReviewTarget('', mainProduct);

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isSafariBrowser() && safariTarget) {
      pendingSafariReviewScroll = { target: safariTarget, startY, hash: '' };
      forceSafariReviewScroll(safariTarget, startY, '');
      return;
    }

    scrollToJunipReviews(nativeReviewSummary);
    return;
  }

  const trigger = getClickableFromEvent(e);
  if (!trigger) return;

  const mainProduct = trigger.closest('[id^="MainProduct-"]');
  if (!mainProduct) return;

  const href = trigger.getAttribute('href') || '';
  const looksLikeReviewLink = href.includes('#') && /review|junip/i.test(href);
  const insideJunipMarkup = pathContainsJunip(e, mainProduct) || isJunipElement(trigger, mainProduct);

  if (!insideJunipMarkup && !looksLikeReviewLink) return;

  const startY = window.pageYOffset;
  const hash = href.includes('#') ? new URL(href, window.location.href).hash : '';

  e.preventDefault();
  e.stopImmediatePropagation();

  if (isSafariBrowser()) {
    const safariTarget = getJunipReviewTarget(hash, mainProduct) || getJunipReviewSectionFallback(mainProduct);
    pendingSafariReviewScroll = safariTarget
      ? { target: safariTarget, startY, hash }
      : null;

    if (pendingSafariReviewScroll && forceSafariReviewScroll(safariTarget, startY, hash)) {
      return;
    }
  }

  if (!scrollToJunipReviews(trigger)) return;

  if (href.includes('#')) {
    if (hash) history.replaceState(null, '', hash);
  }
}, true);

window.addEventListener('hashchange', function() {
  if (!isSafariBrowser() || !pendingSafariReviewScroll?.target) return;

  const { target, startY, hash } = pendingSafariReviewScroll;
  pendingSafariReviewScroll = null;
  forceSafariReviewScroll(target, startY, hash);
});

document.addEventListener('click', function(e) {
  const toggleEl = e.target.closest('[data-toggle-popup]');
  if (!toggleEl) return;
  e.preventDefault();

  const popupAttr = toggleEl.getAttribute('data-toggle-popup');
  const builder = document.querySelector('.sc-builder');
  if (!builder) return;

  const popup = builder.querySelector(`[data-popup="${popupAttr}"]`);
  if (popup) {
    popup.classList.toggle('opened');
    popup.classList.toggle('fade');

    const anyPopupOpen = builder.querySelector('.cpt-popup-container.opened');
    document.documentElement.classList.toggle('disable-scroll', !!anyPopupOpen);
  }
});

document.addEventListener('click', function(e) {
  const builder = document.querySelector('.sc-builder');
  if (!builder) return;

  const popupContainer = e.target.closest('.cpt-popup-container');
  if (!popupContainer) return;

  if (!e.target.closest('.cpt-popup-content')) {
    popupContainer.classList.remove('opened', 'fade');

    const anyPopupOpen = builder.querySelector('.cpt-popup-container.opened');
    document.documentElement.classList.toggle('disable-scroll', !!anyPopupOpen);
  }
});

// FAQ Page
const faqSection = document.querySelector('.collapsible-blocks');
if (faqSection) {
  document.addEventListener('click', function (e) {
    const block = e.target.closest('.collapsible-blocks__block');
    if (!block) return;

    const category = block.dataset.category;

    document.querySelectorAll('.collapsible-blocks__block').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('.collapsible-blocks__container').forEach(el => el.classList.remove('visible'));

    block.classList.add('active');
    const targetContainer = document.querySelector(`.collapsible-blocks__container[data-category="${category}"]`);
    if (targetContainer) {
      targetContainer.classList.add('visible');

      const header = document.querySelector('.section-header');
      const announcement = document.querySelector('.announcement-bar-section');

      const headerHeight = header ? header.offsetHeight : 0;
      const announcementHeight = announcement ? announcement.offsetHeight : 0;

      const totalHeight = headerHeight + announcementHeight;

      const top = targetContainer.getBoundingClientRect().top + window.scrollY - totalHeight;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  });
}

const accordionButtons = document.querySelectorAll('[data-toggle-collapsible]');

if (accordionButtons.length) {
  accordionButtons.forEach((button) => {
    button.addEventListener('click', function (e) {

      e.preventDefault();

      const container = button.closest('[data-collapsible-container]');
      if (!container) return;

      const content = container.querySelector('[data-collapsible-content]');
      if (!content) return;

      const isOpen = container.classList.toggle('opened');
      button.classList.toggle('opened', isOpen);

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
    });
  });
}

class IngredientsWithTabs extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      tabs: this.querySelectorAll('[data-tab]'),
      tiedToTab: this.querySelectorAll('[data-tied-to-tab]'),
    }

    if (this.elements.tabs.length) {
      this.elements.tabs.forEach(
        (tab) => tab.addEventListener('click', this.handleTabClick.bind(this))
      );
    }
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;

    this.elements.tabs.forEach(
      (tab) => tab.setAttribute('aria-active', false)
    );

    clickedTab.setAttribute('aria-active', true);

    this.elements.tiedToTab.forEach((tiedToTab) => {
      const relatedTabsArray = JSON.parse(tiedToTab.querySelector('[data-related-tabs-json]').innerHTML);
      
      relatedTabsArray.forEach((item, index) => {
        relatedTabsArray[index] = item.replaceAll('\n','');
      });
      tiedToTab.setAttribute('aria-active', relatedTabsArray.includes(clickedTab.id));
    });
  }

  connectedCallback() {
    if(window.location.search && this.elements.tabs.length) {
      const params = new URL(location.href).searchParams;
      const tabIdFromParams = params.get('tab');
      if (tabIdFromParams) {
        this.elements.tabs.forEach(
          (tab) => {
            if (tab.id == tabIdFromParams) {
              tab.click();
            }
          }
        )
      }
      
    }
  }
}

customElements.define('ingredients-with-tabs', IngredientsWithTabs);

// Floating CTA Button

class FloatingCTAButton extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      anchor: this.querySelector('[data-anchor]'),
      floatingContainer: this.querySelector('[data-floating-container]'),
      clickATCButton: this.querySelector('[data-click-atc-button]'),
      scrollLink: this.querySelector('a.cfc-button[href^="#"]'),
    }

    if (this.elements.clickATCButton) {
      this.elements.clickATCButton.addEventListener('click', this.handleATCButtonClick.bind(this));
    }

    if (this.elements.scrollLink) {
      this.elements.scrollLink.addEventListener('click', this.handleScrollLinkClick.bind(this));
    }
  }

  handleScroll(event) {
    const anchorTopPosition = this.elements.anchor.offsetTop;
    const windowScrollY = window.scrollY;
    this.elements.floatingContainer.setAttribute('aria-hidden', !(windowScrollY > anchorTopPosition));
  }

  handleScrollLinkClick(event) {
    const hash = this.elements.scrollLink.getAttribute('href');
    if (!hash || hash === '#') return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;

    event.preventDefault();
    const resolveTop = () => {
      const margin = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
      return Math.max(0, target.getBoundingClientRect().top + window.scrollY - margin);
    };
    // Follow layout changes as the sticky header reappears during the scroll.
    animateWindowScroll(resolveTop(), 650, resolveTop);
    window.history.replaceState(window.history.state, '', hash);
  }

  handleATCButtonClick(event) {
    event.preventDefault();
    const ATCButton = document.querySelector('.cpt-submit-button');
    if (ATCButton) {
      ATCButton.click();
    }
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }
};

customElements.define('floating-cta-button', FloatingCTAButton);

// Shared sticky-bar clearance for accessibility and optional Frontrow launchers.

(function () {
  var pending = false;
  var observedDocks = new WeakSet();
  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function syncFloatingTools() {
    pending = false;
    var clearance = 0;
    document.querySelectorAll('.cfc-container, .offer-checkout').forEach(function (dock) {
      if (resizeObserver && !observedDocks.has(dock)) {
        observedDocks.add(dock);
        resizeObserver.observe(dock);
      }
      var active = dock.matches('.cfc-container[aria-hidden="false"], .offer-checkout.is-mobile-dock');
      if (!active) return;
      var style = window.getComputedStyle(dock);
      var height = dock.getBoundingClientRect().height;
      if (style.position !== 'fixed' || style.visibility === 'hidden' || height === 0) return;
      clearance = Math.max(clearance, height + (parseFloat(style.bottom) || 0) + 12);
    });
    var value = Math.ceil(Math.max(16, clearance)) + 'px';
    if (document.documentElement.style.getPropertyValue('--frontrow-tools-bottom') !== value) {
      document.documentElement.style.setProperty('--frontrow-tools-bottom', value);
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(syncFloatingTools);
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
  });
  window.addEventListener('resize', schedule);
  document.addEventListener('frontrow:updated', schedule);
  schedule();
})();
